import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store' ].join('/');
const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @callback ProceedFn
 * @param {string} [path]
 * @returns {void}
 */

/**
 * @typedef {Object} GuardOpts
 * @property {string} namespace
 * @property {import('vue-router/types').default} router
 * @property {import('vuex').Store} store
 * @property {(error: Error, proceed: ProceedFn, opts: GuardOpts) => void} errorHandler
 */

/**
 * @param {import('vue').Component} Vue
 * @param {GuardOpts} opts
 */
function install (Vue, opts) {
  opts = Object.assign({ namespace: constants.NAMESPACE }, opts);
  const namespace = opts.namespace;
  const router = opts.router;
  const store = opts.store;
  if (!router) throw new Error(`${nms}: Vue router is required`);
  if (!store) throw new Error(`${nms}: Vuex store is required`);
  if (!store.state[namespace]) throw new Error(`${nms}: Organizations store plugin must be installed`);
  router.beforeEach(async (to, from, next) => {
    const match = to.matched.some(r => r.meta.requiresOrganizationMemberships || r.meta.requiresActiveOrganization);
    if (!match) return next();
    try {
      log('guarding path', to.fullPath);

      const memberships = await store.dispatch(namespace + '/getCurrentUserMemberships');

      log('memberships', memberships);

      // already logged in
      if (memberships.length) return next(true);

      // no handling
      throw new Error(`Authentication required in route ${to.path}`);
    } catch (error) {
      log('signin error', error);

      const proceed = (path = error) => {
        // no handling
        next(path);
      };

      // custom handling
      if (typeof opts.errorHandler === 'function') return opts.errorHandler(error, proceed, opts);

      proceed();
    }
  });
}

export default { install };
